import './LeftColumn.css';

function LeftColumn(){
    return (
        <div className='left-column'>
        </div>
    );
}

export default LeftColumn;